import { GridColumns } from '@mui/x-data-grid-pro';
import { formatTime } from 'app/components/Candidate/helper/StringFormatter';
import { XGridOverflowCell } from 'app/components/Common/XGrid/cells/XGridOverflowCell';
import { ConversationCount } from 'app/components/Notification/Common/ConversationCount';
import { MISSING_FIELD } from 'app/components/Notification/Constants';
import { convertToPST } from 'app/helpers/dateHelper';

import { formatPhoneNumber } from 'app/helpers/phoneHelpers';
import React from 'react';

export const ReportCommunicationView = (t): GridColumns => [
  {
    field: 'communicationType',
    headerName: t('notification.reports.communicationType'),
    width: 250,
  },
  {
    field: 'contactName',
    headerName: t('notification.reports.contactName'),
    width: 200,
  },
  {
    field: 'contactInfo',
    width: 200,
    headerName: t('notification.reports.contactInfo'),
  },
  {
    field: 'date',
    width: 250,
    headerName: t('notification.reports.date'),
  },
  {
    field: 'from',
    width: 200,
    headerName: t('notification.reports.from'),
  },
  {
    field: 'status',
    width: 250,
    headerName: t('notification.reports.status'),
  },
  {
    field: 'communicationDirection',
    width: 250,
    headerName: t('notification.reports.communicationDirection'),
    renderCell: XGridOverflowCell()(),
    sortable: false,
  },
];

export const ReportCommunicationVisibilityModel = {
  communicationType : true,
  contactName : true,
  contactInfo : true,
  date : true,
  from : true,
  status : true,
  communicationDirection : true
}

export const flattenedCommunicationGridRow = logs => {
  if (logs) {
    const logData = logs.map((log, index) => {
      return {
        id: log.id,
        communicationType: log.channel === 'Conversation' ? 'SMS' : log.channel === 'Voice' ? 'Call' : 'Email',
        contactName: log.message.tos.find(Boolean)?.name,
        contactInfo:
          log.channel === 'Conversation' || log.channel === 'Voice'
            ? log.message.tos.find(Boolean)?.phoneNumber?.length > 10 &&
              log.message.tos.find(Boolean)?.phoneNumber.includes('71')
              ? formatPhoneNumber(log.message.tos.find(Boolean)?.phoneNumber.substring(2)) ?? MISSING_FIELD
              : formatPhoneNumber(log.message.tos.find(Boolean)?.phoneNumber) ?? MISSING_FIELD
            : log.message.tos.find(Boolean)?.email ?? MISSING_FIELD,

        date: `${convertToPST(log?.publishedOn, 'MM/DD/YYYY')} | ${formatTime(
          convertToPST(log?.publishedOn, 'HH:mm'),
        )}`,
        from: log.message.sender.name,
        status:
          log.channel === 'Email'
            ? log?.deliveryStatus && log?.deliveryStatus[0].toUpperCase() + log?.deliveryStatus.slice(1)
            : log?.response?.disposition?.replace(/([A-Z][a-z])/g, ' $1').replace(/(\d)/g, ' $1') || MISSING_FIELD,
        rowID: log?.id,
        communicationDirection:
          log.channel === 'Conversation' ? (
            <ConversationCount
              channel={log.channel}
              outboundCount={log?.message.outboundCount}
              inboundCount={log?.message.inboundCount}
              undeliveredCount={log?.message.undeliveredMessagesCount}
            />
          ) : log?.message.direction === null ? (
            MISSING_FIELD
          ) : (
            <ConversationCount channel={log?.channel} direction={log?.message?.direction} />
          ),
      };
    });
    return logData;
  } else return [];
};
